import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { animate, AUTO_STYLE, state, style, transition, trigger } from '@angular/animations';
import { MenuItems } from '../../shared/menu-items/menu-items';
import { LoginService } from '../../services/login.service';
import { Usuario } from '../../models/usuario';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { NotificacionPerfilService } from '../../services/notificacionPerfil.service';
import { UsuarioService } from '../../services/usuario.service';
import { NotificacionPerfil } from '../../models/notificacionPerfil';
import * as moment from 'moment';
moment.locale("es");

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    styleUrls: ['./admin.component.scss'],
    providers: [
        LoginService
    ],
    animations: [
        trigger('mobileMenuTop', [
            state('no-block, void', style({
                overflow: 'hidden',
                height: '0px',
            })),
            state('yes-block', style({
                height: AUTO_STYLE,
            })),
            transition('no-block <=> yes-block', [
                animate('400ms ease-in-out')
            ])
        ]),
        trigger('slideInOut', [
            state('in', style({
                transform: 'translate3d(0, 0, 0)'
            })),
            state('out', style({
                transform: 'translate3d(100%, 0, 0)'
            })),
            transition('in => out', animate('400ms ease-in-out')),
            transition('out => in', animate('400ms ease-in-out'))
        ]),
        trigger('slideOnOff', [
            state('on', style({
                transform: 'translate3d(0, 0, 0)'
            })),
            state('off', style({
                transform: 'translate3d(100%, 0, 0)'
            })),
            transition('on => off', animate('400ms ease-in-out')),
            transition('off => on', animate('400ms ease-in-out'))
        ]),
        trigger('fadeInOutTranslate', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('400ms ease-in-out', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translate(0)' }),
                animate('400ms ease-in-out', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class AdminComponent implements OnInit {
  public adminSubscribe: Subscription;
  public identity: Usuario;
  navType: string; /* st1, st2(default), st3, st4 */
  themeLayout: string; /* vertical(default) */
  layoutType: string; /* dark, light */
  verticalPlacement: string; /* left(default), right */
  verticalLayout: string; /* wide(default), box */
  deviceType: string; /* desktop(default), tablet, mobile */
  verticalNavType: string; /* expanded(default), offcanvas */
  verticalEffect: string; /* shrink(default), push, overlay */
  vNavigationView: string; /* view1(default) */
  pcodedHeaderPosition: string; /* fixed(default), relative*/
  pcodedSidebarPosition: string; /* fixed(default), absolute*/
  headerTheme: string; /* theme1(default), theme2, theme3, theme4, theme5, theme6 */
  logoTheme: string; /* theme1(default), theme2, theme3, theme4, theme5, theme6 */

  innerHeight: string;
  windowWidth: number;

  toggleOn: boolean;

  headerFixedMargin: string;
  navBarTheme: string; /* theme1, themelight1(default)*/
  activeItemTheme: string; /* theme1, theme2, theme3, theme4(default), ..., theme11, theme12 */

  isCollapsedMobile: string;
  isCollapsedSideBar: string;

  chatToggle: string;
  chatToggleInverse: string;
  chatInnerToggle: string;
  chatInnerToggleInverse: string;

  menuTitleTheme: string; /* theme1, theme2, theme3, theme4, theme5(default), theme6 */
  itemBorder: boolean;
  itemBorderStyle: string; /* none(default), solid, dotted, dashed */
  subItemBorder: boolean;
  subItemIcon: string; /* style1, style2, style3, style4, style5, style6(default) */
  dropDownIcon: string; /* style1(default), style2, style3 */
  configOpenRightBar: string;
  isSidebarChecked: boolean;
  isHeaderChecked: boolean;

  @ViewChild('searchFriends') search_friends: ElementRef;

  public config: any;

  public lNotificaciones: NotificacionPerfil[] = [];
  private readonly defaultEmpresaLogo: string = "assets/images/platform/sol-admin-logo.svg";
  private readonly defaultEmpresaColorPrimario: string = "#4f4035";
  private readonly defaultEmpresaColorSecundario: string = "#33271f";
  private readonly defaultEmpresaColorAcento: string = "#c58b40";

  public empresaLogo: string = this.defaultEmpresaLogo;
  public empresaColorPrimario: string = this.defaultEmpresaColorPrimario;
  public empresaColorSecundario: string = this.defaultEmpresaColorSecundario;
  public empresaColorAcento: string = this.defaultEmpresaColorAcento;
  public modoOscuro: boolean = false;

  constructor(public menuItems: MenuItems, private _loginService: LoginService, private _toastr: ToastrService, private _router: Router, private _notificacionPerfil: NotificacionPerfilService, private _usuarioService: UsuarioService) {
    this.navType = 'st5';
    this.themeLayout = 'vertical';
    this.vNavigationView = 'view1';
    this.verticalPlacement = 'left';
    this.verticalLayout = 'wide';
    this.deviceType = 'desktop';
    this.verticalNavType = 'expanded';
    this.verticalEffect = 'shrink';
    this.pcodedHeaderPosition = 'fixed';
    this.pcodedSidebarPosition = 'fixed';
    this.headerTheme = 'theme1';
    this.logoTheme = 'theme1';

    this.toggleOn = true;

    this.headerFixedMargin = '80px';
    this.navBarTheme = 'themelight1';
    this.activeItemTheme = 'theme4';

    this.isCollapsedMobile = 'no-block';
    this.isCollapsedSideBar = 'no-block';

    this.chatToggle = 'out';
    this.chatToggleInverse = 'in';
    this.chatInnerToggle = 'off';
    this.chatInnerToggleInverse = 'on';

    this.menuTitleTheme = 'theme5';
    this.itemBorder = true;
    this.itemBorderStyle = 'none';
    this.subItemBorder = true;
    this.subItemIcon = 'style6';
    this.dropDownIcon = 'style1';
    this.isSidebarChecked = true;
    this.isHeaderChecked = true;

    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + 'px';
    this.windowWidth = window.innerWidth;
    this.setMenuAttributes(this.windowWidth);
    this.identity = new Usuario();
    this.identity.foto = environment.imagenPerfil;
  }

  ngOnInit() {
    this.identity = this._loginService.getIdentity() as Usuario;
    if (this.identity == null) {
      this._router.navigate(['/login']);
    }
    this.menuItems.setMenu(this.MenuPorPerfil(this.identity));
    this.AplicaMarcaEmpresa();
    this.AplicaModoOscuro(this.identity?.modoOscuro === true);
    this.setBackgroundPattern('pattern2');
    this.Notificaciones();
  }

  ngDoCheck() {
    this.identity = this._loginService.getIdentity();
    if (this.identity == undefined) {
      this.identity = new Usuario();
      this.identity.foto = environment.imagenPerfil;
    }
    else {
      let recargarNotificaciones = localStorage.getItem('recargaNotificaciones') as string;
      if (recargarNotificaciones == "1") {
        localStorage.removeItem('recargaNotificaciones');
        this.Notificaciones();
      }
    }
  }
  ngOnDestroy(): void {
    if (this.adminSubscribe) { this.adminSubscribe.unsubscribe(); }
    document.querySelector('body')?.classList.remove('muebles-dark-mode');
  }

  onResize(event) {
    this.innerHeight = event.target.innerHeight + 'px';
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (this.deviceType === 'tablet' && this.windowWidth >= 768 && this.windowWidth <= 1024) {
      reSizeFlag = false;
    } else if (this.deviceType === 'mobile' && this.windowWidth < 768) {
      reSizeFlag = false;
    }
    /* for check device */
    if (reSizeFlag) {
      this.setMenuAttributes(this.windowWidth);
    }
  }

  setMenuAttributes(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.deviceType = 'tablet';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'push';
    } else if (windowWidth < 768) {
      this.deviceType = 'mobile';
      this.verticalNavType = 'offcanvas';
      this.verticalEffect = 'overlay';
    } else {
      this.deviceType = 'desktop';
      this.verticalNavType = 'expanded';
      this.verticalEffect = 'shrink';
    }
  }

  toggleOpened() {
    if (this.windowWidth < 768) {
      this.toggleOn = this.verticalNavType === 'offcanvas' ? true : this.toggleOn;
    }
    this.verticalNavType = this.verticalNavType === 'expanded' ? 'offcanvas' : 'expanded';
  }

  onClickedOutside(e: Event) {
    if (this.windowWidth < 768 && this.toggleOn && this.verticalNavType !== 'offcanvas') {
      this.toggleOn = true;
      this.verticalNavType = 'offcanvas';
    }
  }

  onMobileMenu() {
    this.isCollapsedMobile = this.isCollapsedMobile === 'yes-block' ? 'no-block' : 'yes-block';
  }

  toggleChat() {
    this.chatToggle = this.chatToggle === 'out' ? 'in' : 'out';
    this.chatToggleInverse = this.chatToggleInverse === 'out' ? 'in' : 'out';
    this.chatInnerToggle = 'off';
    this.chatInnerToggleInverse = 'off';
  }

  toggleChatInner() {
    this.chatInnerToggle = this.chatInnerToggle === 'off' ? 'on' : 'off';
    this.chatInnerToggleInverse = this.chatInnerToggleInverse === 'off' ? 'on' : 'off';
  }

  searchFriendList(e: Event) {
    const search = (this.search_friends.nativeElement.value).toLowerCase();
    let search_input: string;
    let search_parent: any;
    const friendList = document.querySelectorAll('.userlist-box .media-body .chat-header');
    Array.prototype.forEach.call(friendList, function (elements, index) {
      search_input = (elements.innerHTML).toLowerCase();
      search_parent = (elements.parentNode).parentNode;
      if (search_input.indexOf(search) !== -1) {
        search_parent.classList.add('show');
        search_parent.classList.remove('hide');
      } else {
        search_parent.classList.add('hide');
        search_parent.classList.remove('show');
      }
    });
  }

  toggleOpenedSidebar() {
    this.isCollapsedSideBar = this.isCollapsedSideBar === 'yes-block' ? 'no-block' : 'yes-block';
  }

  toggleRightbar() {
    this.configOpenRightBar = this.configOpenRightBar === 'open' ? '' : 'open';
  }

  setSidebarPosition() {
    this.isSidebarChecked = !this.isSidebarChecked;
    this.pcodedSidebarPosition = this.isSidebarChecked === true ? 'fixed' : 'absolute';
  }

  setHeaderPosition() {
    this.isHeaderChecked = !this.isHeaderChecked;
    this.pcodedHeaderPosition = this.isHeaderChecked === true ? 'fixed' : 'relative';
    this.headerFixedMargin = this.isHeaderChecked === true ? '80px' : '';
  }

  setBackgroundPattern(pattern) {
    document.querySelector('body').setAttribute('themebg-pattern', pattern);
  }

  setLayoutType(type: string) {
    this.layoutType = type;
    if (type === 'dark') {
      this.headerTheme = 'theme6';
      this.navBarTheme = 'theme1';
      this.logoTheme = 'theme6';
      document.querySelector('body').classList.add('dark');
    } else {
      this.headerTheme = 'theme1';
      this.navBarTheme = 'themelight1';
      this.logoTheme = 'theme1';
      document.querySelector('body').classList.remove('dark');
    }
  }

  setNavBarTheme(theme: string) {
    if (theme === 'themelight1') {
      this.navBarTheme = 'themelight1';
    } else {
      this.navBarTheme = 'theme1';
    }
  }

  MenuPorPerfil(usuario: Usuario) {
    return this._loginService.getMenu();
  }
  ToggleModoOscuro() {
    this.modoOscuro = !this.modoOscuro;
    this.AplicaModoOscuro(this.modoOscuro);

    const usuario = { ...this.identity, modoOscuro: this.modoOscuro } as Usuario;
    this.adminSubscribe = this._usuarioService.ModoOscuro(usuario).subscribe(
      response => {
        if (response.codigoError >= 0 && response.exitoso) {
          this.identity.modoOscuro = this.modoOscuro;
          this._loginService.actualizaIdentity(this.identity);
        } else {
          this.modoOscuro = !this.modoOscuro;
          this.AplicaModoOscuro(this.modoOscuro);
          this._toastr.warning(response.mensaje || 'No fue posible actualizar el tema.');
        }
      }, err => {
        this.modoOscuro = !this.modoOscuro;
        this.AplicaModoOscuro(this.modoOscuro);
        if (err.status == 0) {
          this._router.navigate(['/login']);
        } else {
          this._toastr.error('No fue posible actualizar el tema.');
        }
      });
  }

  AplicaModoOscuro(activo: boolean) {
    this.modoOscuro = activo;
    this.layoutType = activo ? 'dark' : 'light';
    this.headerTheme = activo ? 'theme6' : 'theme1';
    this.navBarTheme = activo ? 'theme1' : 'themelight1';
    this.logoTheme = activo ? 'theme6' : 'theme1';
    document.querySelector('body')?.classList.toggle('muebles-dark-mode', activo);
  }
  AplicaMarcaEmpresa() {
    this.empresaLogo = this.defaultEmpresaLogo;
    this.empresaColorPrimario = this.defaultEmpresaColorPrimario;
    this.empresaColorSecundario = this.defaultEmpresaColorSecundario;
    this.empresaColorAcento = this.defaultEmpresaColorAcento;

    const empresa = this.identity?.empresa;
    const tieneEmpresaAsignada = empresa != null && empresa.id != null && empresa.id > 0;

    if (tieneEmpresaAsignada) {
      this.empresaLogo = empresa.logoPrincipal || this.empresaLogo;
      this.empresaColorPrimario = empresa.colorPrimario || this.empresaColorPrimario;
      this.empresaColorSecundario = empresa.colorSecundario || this.empresaColorSecundario;
      this.empresaColorAcento = empresa.colorAcento || this.empresaColorAcento;
    }

    document.documentElement.style.setProperty('--empresa-primary', this.empresaColorPrimario);
    document.documentElement.style.setProperty('--empresa-secondary', this.empresaColorSecundario);
    document.documentElement.style.setProperty('--empresa-accent', this.empresaColorAcento);
  }
  logOut() {
    this.identity.boton = true;
    this.adminSubscribe = this._loginService.CierraSesion(this.identity).subscribe(
      response => {
        if (response.codigoError >= 0) {
          if (response.exitoso) {
            this._loginService.limpiaSesion();
            this.identity = null;
            this._router.navigate(['/login']);
            this._toastr.success(response.mensaje);
          } else {
            this._toastr.warning(response.mensaje);
          }
        }
        else {
          this._toastr.error(response.mensaje);
        }
      }, err => {
        if (err.status == 0) {
          this._router.navigate(['/login']);
        }
        else {
          this._toastr.error("¡Sucedió un error inesperado al cerrar la sesión!");
        }
      });
  }
  Notificaciones() {
    this.adminSubscribe = this._notificacionPerfil.PorPerfil(this.identity.perfil).subscribe(
      response => {
        if (response.codigoError >= 0) {
          if (response.exitoso) {
            if (response.cuerpo != null) {
              this.lNotificaciones = [];
              this.lNotificaciones = response.cuerpo;
            }
          }
        }
        else {
          this._toastr.error(response.mensaje);
        }
      }, err => {
        if (err.status == 0) {
          this._router.navigate(['/login']);
        }
        else {
          this._toastr.error("¡Sucedió un error inesperado al obtener las notificaciones!");
        }
      });
  }
  Elimina(notificacion: NotificacionPerfil) {
    this.adminSubscribe = this._notificacionPerfil.Elimina(notificacion).subscribe(
      response => {
        if (response.codigoError >= 0) {
          if (response.exitoso) {
            this.Notificaciones();
          }
          else {
            this._toastr.error(response.mensaje);
          }
        }
        else {
          this._toastr.error(response.mensaje);
        }
      }, err => {
        if (err.status == 0) {
          this._router.navigate(['/login']);
        }
        else {
          this._toastr.error("¡Sucedió un error inesperado al eliminar la notificación!");
        }
      });
  }
}





